import { useState, useRef, useEffect } from 'react';
import { IonGrid, IonRow, IonCol, IonLabel, IonButton } from '@ionic/react';
import { Storage } from '@capacitor/storage';
import { useHistory } from 'react-router-dom';
import { CheckObject } from '../../defines/Functions';
import HotelCity from './modals/HotelCity';
import HotelPassenger from './modals/HotelPassenger';
import MyDatepicker from '../MyDatepicker';
interface Props {
    data: any
}
const Hotel = (props: Props) => {
    let hotelJson = {} as any;
    const [state, setState] = useState({
        hotelCityValue: {} as any,
        hotelPassengerValue: [{
            adults: 2,
            childs: 0,
            childsAges: []
        }],
        datepickerValue: [] as any,
    })
    const [required, setRequired] = useState({
        city: false,
        date: false
    });
    const handleCityCallback = (childData: any) => {
        let childDataObj = JSON.parse(childData);
        setState({ ...state, hotelCityValue: childDataObj });
        setRequired({ ...required, city: false });
    }
    const handlePassengerCallback = (childData: any) => {
        setState({ ...state, hotelPassengerValue: childData });
    }
    const handleDatepickerCallback = (childDataObj: any) => {
        setState({ ...state, datepickerValue: childDataObj });
        setRequired({ ...required, date: false });
    }
    hotelJson = [{
        "dates": state.datepickerValue,
        "rooms": state.hotelPassengerValue,
        "city": state.hotelCityValue
    }];
    const setHotelJson = async () => {
        await Storage.set({
            key: 'hotelJson',
            value: JSON.stringify(hotelJson),
        });
    };
    const clearHotelJson = async () => {
        await Storage.remove({ key: 'hotelJson' });
    };
    const history = useHistory();
    const onSearchCLick = () => {
        let isRequired = false;
        if (CheckObject(state.hotelCityValue)) {
            setRequired(prevRequired => { return { ...prevRequired, city: true } });
            isRequired = true;
        }
        if (state.datepickerValue.length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, date: true } });
            isRequired = true;
        }
        if (!isRequired) {
            clearHotelJson();
            setHotelJson();
            history.push({
                pathname: '/search/hotel'
            });
        }
    }
    const didGetFlightJson = useRef(false);
    useEffect(() => {
        if (!didGetFlightJson.current) {
            const getFlightJson = async () => {
                const { value } = await Storage.get({ key: 'hotelJson' });
                if (value !== null) {
                    const objectValue = JSON.parse(value);
                    let hotelPassengerValues = [] as any;
                    if (objectValue.length) {
                        objectValue[0].rooms.forEach((room: any) => {
                            hotelPassengerValues.push(room);
                        })
                        setState({
                            ...state,
                            hotelCityValue: objectValue[0].city,
                            hotelPassengerValue: hotelPassengerValues,
                            datepickerValue: objectValue[0].dates
                        });
                    }
                }
            };
            getFlightJson();
            didGetFlightJson.current = true;
        }
    }, [props, state]);
    return (
        <IonGrid>
            <IonRow>
                <IonCol size="12">
                    <div className="form-input-container">
                        <IonRow>
                            <IonCol size="12">
                                <IonLabel>
                                    انتخاب مقصد
                                    {required.city ? <span className="required">الزامی</span> : null}
                                </IonLabel>
                                <HotelCity hotelCityParentCallback={handleCityCallback} data={props.data.city} itemValue={state.hotelCityValue.title} />
                            </IonCol>
                            <IonCol size="12">
                                <IonLabel>
                                    تاریخ ورود / خروج
                                    {required.date ? <span className="required">الزامی</span> : null}
                                </IonLabel>
                                <div className="jalali-datepicker">
                                    <MyDatepicker
                                        value={state.datepickerValue && state.datepickerValue.dates && [new Date(state.datepickerValue.dates[0]), new Date(state.datepickerValue.dates[1])]}
                                        isGregorian={state.datepickerValue.isJalali === 'true' ? true : false}
                                        isRange={true}
                                        datepickerParentCallback={handleDatepickerCallback}
                                    />
                                </div>
                            </IonCol>
                            <IonCol size="12">
                                <IonLabel>
                                    اتاق ها و مسافران
                                </IonLabel>
                                <HotelPassenger hotelPassengerParentCallback={handlePassengerCallback} itemValue={state.hotelPassengerValue} />
                            </IonCol>
                            <IonCol size="12">
                                <IonButton
                                    color="warning"
                                    expand="block"
                                    className={CheckObject(state.hotelCityValue) ? "form-submit-button" : "form-submit-button"}
                                    onClick={onSearchCLick}
                                >
                                    جستجو
                                </IonButton>
                            </IonCol>
                        </IonRow>
                    </div>
                </IonCol>
            </IonRow>
        </IonGrid>
    );
};
export default Hotel;